// Shared matte/steel-blue design tokens — mirrors the per-page `C`/`SANS`/`MONO`
// constants in PortfolioOverview.jsx / Trader_Form.js so new (onboarding)
// components match the rest of the app without duplicating the palette inline.
export const C = {
  bg: '#0a0c11', card: '#0f1218', input: '#13171f', panel: '#0c0e14',
  bright: '#f2f6ff', primary: '#f4f7fc', body: '#9aa6bd', muted: '#6f7c96',
  muted2: '#7b88a2', faint: '#5e6a82',
  accent: '#4d8fc7', accent2: '#3f6fb0', accentText: '#9cc3e4',
  positive: '#46b88a', negative: '#d97b72', amber: '#d9a441',
  hairline: 'rgba(255,255,255,.06)', binance: '#f0b90b', alpaca: '#fcd535',
};
export const MONO = '"IBM Plex Mono", ui-monospace, "SF Mono", Menlo, monospace';
export const SANS = '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
export const BTN_GRAD = 'linear-gradient(180deg,#3d5c7b,#33506b)';
export const CARD = {
  background: C.card, border: `1px solid ${C.hairline}`,
  borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,.22)',
};
export const hexA = (hex, a) => {
  const n = parseInt(hex.replace('#', ''), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};
// Primary (slate-gradient) button style for `<Box component="button">`.
export const primaryBtnSx = (pad = '10px 16px') => ({
  display: 'inline-flex', alignItems: 'center', gap: 1, padding: pad, borderRadius: '10px',
  fontFamily: SANS, fontWeight: 600, fontSize: '13.5px', color: '#e7eef6', textTransform: 'none',
  background: BTN_GRAD, border: `1px solid ${C.hairline}`, cursor: 'pointer', lineHeight: 1.2,
  '&:hover': { background: 'linear-gradient(180deg,#436686,#395a78)' },
  '&:disabled': { opacity: 0.6, cursor: 'default' },
});
